module.exports = "/_next/static/images/partner_logos-dfb301f4d8a34937881c037f47646d27.png";